export const enRegisterCommunityFinished = {
  SA27title: 'Community participation application completed',
  SA27descriptionFirst: 'Currently, we are registering for community participation. We will inform you about the registration result by email or top page.',
  SA27descriptionSecond: 'Please wait for a while.',
}
